import React from "react";
import {Box, Link} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";

export default function AccountRecoveryLinks() {
  return (
    <Box component="nav" aria-label="Account recovery" sx={{display: "flex", flexWrap: "wrap", gap: 2, mb: 2}}>
      <Link component={RouterLink} to="/" sx={{fontWeight: 600}}>Log in</Link>
      <Link component={RouterLink} to="/password/forgot" sx={{fontWeight: 600}}>Reset password</Link>
    </Box>
  );
}
